import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Licenses from "./pages/Licenses";
import "./index.css";
import MarketingSettlement from "./pages/MarketingSettlement";
import PayOffLicense from "./pages/PayOffLicense";
import VendorsList from "./pages/VendorsList";
import LicenseSettlement from "./pages/LicenseSettlement";
import PriceConcurent from "./pages/PriceConcurent";
import VendorReports from "./pages/VendorsReport";
import Unauthorized from "./components/Unauthorized";
import { ConfirmProvider } from "./components/ConfirmContext";
import { ToastProvider } from "./components/Toast/ToastContext";
import ResetPassword from "./pages/ResetPassword";
import SystemCosts from "./pages/SystemCosts";
import GlobalLoader from "./components/GlobalLoader";
import PriceConcurentMissed from "./pages/PriceConcurentMissed";
import AnamorphicParallax from "./pages/AnamorphicParallax";
function App() {
  return (
    <ConfirmProvider>
      <GlobalLoader></GlobalLoader>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="login" element={<Login />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="unauthorized" element={<Unauthorized />} />
            <Route
              element={
                <ProtectedRoute
                  roles={[
                    "Administrator",
                    "Dystrybutor",
                    "Developer",
                    "Tester",
                    "Handlowiec",
                  ]}
                />
              }
            >
              {/* Layout otacza wszystkie chronione strony */}
              <Route element={<Layout />}>
                <Route index element={<Dashboard />} />

                <Route
                  element={
                    <ProtectedRoute
                      roles={["Administrator", "Developer", "Tester"]}
                    />
                  }
                >
                  <Route path="users" element={<Users />} />
                  <Route path="vendors" element={<VendorsList />} />
                  <Route
                    path="anamorphic-parallax"
                    element={<AnamorphicParallax />}
                  />
                </Route>

                <Route path="unauthorized" element={<Unauthorized />} />
                <Route path="koszty" element={<SystemCosts />} />

                <Route path="licenses" element={<Licenses />} />
                <Route path="marketing" element={<MarketingSettlement />} />
                <Route path="payoflicense" element={<PayOffLicense />} />
                <Route path="vendorsReport" element={<VendorReports />} />

                <Route
                  path="licensesettlement"
                  element={<LicenseSettlement />}
                />
                <Route path="priceconcurent" element={<PriceConcurent />} />
                <Route
                  path="priceconcurrentmissed"
                  element={<PriceConcurentMissed />}
                />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </ConfirmProvider>
  );
}

export default App;
